<div class="title-bar">
	<nav aria-label="breadcrumb">
		<ol class="breadcrumb">
			<li class="breadcrumb-item">
				<fa-icon [icon]="ac.sectionIcons.dashboard" class="me-1" size="sm"></fa-icon>
				<a routerLink="..">Dashboard</a>
			</li>
			<li class="breadcrumb-item">Extrsa</li>
		</ol>
	</nav>
</div>


<div class="tab-container">
	<ul class="cp-nav-tabs" id="myTab" role="tablist">
		<li class="cp-nav-item" role="presentation">
			<button type="button" class="cp-nav-tab-link cp-std-tab active" data-bs-toggle="tab" role="tab" aria-selected="true"
				id="nav-locations-tab" aria-controls="nav-locations" data-bs-target="#nav-locations">
				Locations
			</button>
		</li>

		<li class="cp-nav-item" role="presentation">
			<button type="button" class="cp-nav-tab-link cp-std-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
				id="nav-other-tab" aria-controls="nav-other" data-bs-target="#nav-other">
				More
			</button>
		</li>
	</ul>

	<div class="tab-content" id="nav-tabContent">
		<div class="tab-pane show active" role="tabpanel" id="nav-locations" aria-labelledby="nav-locations-tab">

			<div class="p-1">
				Last {{ daysBack | number }} Days
				{{ ac.bullet}}
				mode = {{ mode }}
				{{ ac.bullet}}
				success = {{ success }}

				<div *ngIf="!refreshing" class="row g-0">
					<div *ngFor="let item of locationCounts" class="col-auto">
						<div class="border h-100 text-center" [style]="'width: ' + item['imgWidth'] + 'px;'"
							[ngbTooltip]="item.location + ' count=' + tt.formatNumber(item.theCount)">
							<img [src]="item['__flag']" class="img-fluid" [style]="'maxHeight:' + (item['imgWidth']/2) + 'px;'" />
							<!-- <div class="text-truncate cp-65" style="padding-left: 2px; padding-right: 2px;">
								{{ item.location }}
							</div> -->
							<div class="text-truncate cp-65" style="padding-left: 2px; padding-right: 2px;">
								{{ item.log }}
							</div>
						</div>
					</div>
				</div>
			</div>


		</div>

		<div class="tab-pane" role="tabpanel" id="nav-other" aria-labelledby="nav-other-tab">

		</div>
	</div>
</div>